import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "expand-list-modal" }
const _hoisted_2 = { class: "expand-list-modal__filter" }
const _hoisted_3 = {
  key: 0,
  class: "expand-list-modal__summary"
}
const _hoisted_4 = { class: "expand-list-modal__body" }

import { ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpandListModal',
  props: {
    title: { default: "" },
    placeholder: { default: "Поиск" },
    filter: { default: "" },
    width: { default: 560 },
    height: { default: 640 }
  },
  emits: ["update:filter", "close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emit = __emit

const $modal = ref<InstanceType<typeof BaseModal> | null>(null)

const onOpen = () => $modal.value?.onOpen()
const onClose = () => $modal.value?.onClose()

__expose({ onOpen, onClose })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    title: _ctx.title,
    width: _ctx.width,
    height: _ctx.height,
    onOnClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(AppInput, {
            "model-value": _ctx.filter,
            class: "expand-list-modal__filter-input",
            placeholder: _ctx.placeholder,
            "show-search-button": "",
            debounce: 150,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:filter', $event)))
          }, null, 8, ["model-value", "placeholder"])
        ]),
        (_ctx.$slots.summary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "summary")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _: 3
  }, 8, ["title", "width", "height"]))
}
}

})